import { QueryClient } from "@tanstack/react-query";
import { setupPersistentQueryClient, CACHE_CONFIG } from "./persist";
import { shouldRetryQuery } from "./retry";

// Create the query client instance
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: CACHE_CONFIG.defaultStaleTime,
      gcTime: CACHE_CONFIG.defaultCacheTime,
      retry: shouldRetryQuery,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      retry: 1,
    },
  },
});

// Setup persistence for the query client
setupPersistentQueryClient(queryClient);
